export default __webpack_public_path__ + "static/media/send-risk-analysis-to-customer-icon.db7836dc.svg";